import React from "react";
import { Spinner } from "../../components/";

export default function LoadingScreen({ label }) {
    return (
        <div style={{
            height: "1000px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        }}>
            < Spinner label={label} />
        </div>
    );
}